module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori-3b3c5f90f3aa03122d69a45df0760020.webp";